import styles from './style.module.scss';
import meal1 from '../../../../assets/images/meal1.png';
import meal2 from '../../../../assets/images/meal2.png';
import meal3 from '../../../../assets/images/meal3.png';
import meal4 from '../../../../assets/images/meal4.png';

const MealCarousel = () => {
  return (
    <div className={styles.mealPlanContainer}>
      <div className={styles.mealPlan}>
        {[
          { image: meal1 },
          { image: meal2 },
          { image: meal3 },
          { image: meal4 },
        ].map((item, idx) => (
          <div className={styles.card} key={idx}>
            <div className={styles.cardImage}>
              <img className={styles.image} src={item.image} alt='meal' />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MealCarousel;